import * as R from 'ramda'
import { dataWisCreate } from '@weblite/action/wis'
import { WappInput } from '@weblite-wapps/protocol'
import { E_CANCELED, Mutex } from 'async-mutex'
import { wsReq } from '$setup/ws'
import { wisesStorage } from '$logic/wises/storage'
import { Wis } from '$logic/wises/types'

const mutexes: Record<string, Mutex> = {}

export function getMutex(id: string) {
  if (mutexes[id]) return mutexes[id]
  mutexes[id] = new Mutex()
  return mutexes[id]
}

export const createWisInServer = (wappId: string, input?: WappInput) =>
  wsReq(dataWisCreate({ wappId, customize: input }))
    .then(R.prop('payload'))
    .then(R.tap(console.log))
    .then(R.tap((wis: Wis) => wisesStorage.add(wis)))

export async function getWis(id: string) {
  const wis = wisesStorage.getFromRedux(id)

  if (wis) return wis

  try {
    const mutex = getMutex(`getWis-${id}`)
    return await mutex.runExclusive(async () => {
      const wisItem = await wisesStorage.get(id)
      mutex.cancel()
      delete mutexes[`getWis-${id}`]
      return wisItem
    })
  } catch (e) {
    if (e === E_CANCELED) return wisesStorage.getFromRedux(id)
  }
}
